module.exports = __webpack_public_path__ + "static/a_red-ff31c728ac5f3b13cc946f10d8e4dbd8.jpeg";